import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
var ReactSuperSelect = require('react-super-select')
var ReactSlider = require('react-slider')

class Notifications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterBy: {}, sortBy: 'name', sortOrder: 1,
            loading: false,
            adding: false,
            uploading: false,
            editing: false,
            error: '',
            deleting: false,
            wizard: false,
            expand: {}
        };
    }

    add = (e) => {
        this.setState({ adding: true, loading: false })
    }

    startWizard = () => {
        this.setState({ error: false, adding: false, editing: JSON.parse(JSON.stringify(this.props.data.Notifications.defaultTemplate)), file: null, wizard: 0, loading: false })
    }

    startFileUpload = () => {
        this.setState({ contactList: false, binaryData: false, adding: false, uploading: true, loading: false })
    }

    setFileName = (e) => {
        if (e.target.files.length > 0) {
            this.setState({ contactList: e.target.files[0] })
        } else {
            this.setState({ contactList: false })
        }
        this.fileReader = new FileReader()
        this.fileReader.onload = (event) => {
            this.setState({ binaryData: this.fileReader.result.split(';base64,').pop() })
        }
        this.fileReader.readAsDataURL(e.target.files[0])
    }
    confirmContactUpload = (e) => {
        this.setState({ loading: true }, () => {
            this.props.ws.send(JSON.stringify({ route: 'uploadContactList', contactList: { data: this.state.binaryData, file: this.state.contactList.name } }))
        });

    }
    addNewNotification = (e) => {
        if (this.state.editing.name.length < 1) {
            this.setState({ error: 'Please add a notification name before proceeding.', loading: false })
            return false
        } else if (!this.state.editing.file) {
            this.setState({ error: 'Please select a contact list before proceeding.', loading: false })
            return false
        } else if (!this.state.editing.call.enabled && !this.state.editing.sms.enabled && !this.state.editing.email.enabled) {
            this.setState({ error: 'Please select at least one contact method before proceeding.', loading: false })
            return false
        } else if (((this.state.editing.call.enabled && !this.state.editing.call.field) || (this.state.editing.sms.enabled && !this.state.editing.sms.field) || (this.state.editing.email.enabled && !this.state.editing.email.field))) {
            this.setState({ error: 'Please select a contact list field for each selected contact method before proceeding.', loading: false })
            return false
        }

        for (var language in this.state.editing.call.body) {
            if (this.state.editing.call.enabled && this.state.editing.call.body[language].length < 1) {
                this.setState({ error: 'Please enter a message body before proceeding.', loading: false })
                return false
            }
        }

        this.setState({ loading: true });

        this.props.ws.send(JSON.stringify({ route: 'addNotification', notification: this.state.editing }))
    }
    edit = (template) => (e) => {
        this.setState({ editing: template, file: this.props.data.Contacts[template.file], loading: false })
    }
    editNotification = (e) => {
        if (this.state.editing.name.length < 1) {
            this.setState({ error: 'Please add a notification name before proceeding.', loading: false })
            return false
        } else if (!this.state.editing.file) {
            this.setState({ error: 'Please select a contact list before proceeding.', loading: false })
            return false
        } else if (!this.state.editing.call.enabled && !this.state.editing.sms.enabled && !this.state.editing.email.enabled) {
            this.setState({ error: 'Please select at least one contact method before proceeding.', loading: false })
            return false
        } else if (((this.state.editing.call.enabled && !this.state.editing.call.field) || (this.state.editing.sms.enabled && !this.state.editing.sms.field) || (this.state.editing.email.enabled && !this.state.editing.email.field))) {
            this.setState({ error: 'Please select a contact list field for each selected Contact Method before proceeding.', loading: false })
            return false
        } else if (this.state.editing.call.customFlow === true) {
            this.setState({ error: 'Please select a custom flow within the Calls container.', loading: false })
            return false
        } else if (this.state.editing.scheduling.variable === true) {
            this.setState({ error: '"Date From File" is selected. Please select a corresponding date column in the Scheduling container.', loading: false })
            return false
        } else if (Object.keys(this.state.editing.call.body).length > 1 && !this.state.editing.languageVariable) {
            this.setState({ error: 'Multiple Languages are indicated. Please select a contact list language field in the Language container.', loading: false })
            return false
        } else if (!this.state.editing.call.customFlow) {
            if (this.state.editing.call.enabled) {
                for (var language in this.state.editing.call.body) {
                    if (this.state.editing.call.body[language].length < 5) {
                        this.setState({ error: 'Please select a custom flow, or specify a message body for each selected language in the Calls container.', loading: false })
                        return false
                    }
                }
                if (this.state.editing.call.preConfirm.enabled) {
                    for (var language in this.state.editing.call.preConfirm.message) {
                        if (this.state.editing.call.preConfirm.message[language].length < 5) {
                            this.setState({ error: 'Pre-message Confirmation is enabled. Please specify a confirmation message for each selected language in the Calls container.', loading: false })
                            return false
                        }
                    }
                }
            }
            if (this.state.editing.sms.enabled) {
                for (var language in this.state.editing.sms.body) {
                    if (this.state.editing.sms.body[language].length < 5) {
                        this.setState({ error: 'Please specify a message body for each selected language in the SMS container.', loading: false })
                        return false
                    }
                }
            }
            if (this.state.editing.email.enabled) {
                for (var language in this.state.editing.email.subject) {
                    if (this.state.editing.email.subject[language].length < 1) {
                        this.setState({ error: 'Please specify a message subject for each selected language in the Email container.', loading: false })
                        return false
                    }
                }
                for (var language in this.state.editing.email.body) {
                    if (this.state.editing.email.body[language].length < 5) {
                        this.setState({ error: 'Please specify a message body for each selected language in the Email container.', loading: false })
                        return false
                    }
                }
            }
        }
        this.setState({ loading: true });
        this.props.ws.send(JSON.stringify({ route: 'editNotification', notification: this.state.editing }))
    }
    delete = (template) => (e) => {
        e.stopPropagation()
        this.setState({ deleting: template, loading: false })
    }
    confirmDelete = (e) => {
        this.setState({ loading: true });
        this.props.ws.send(JSON.stringify({ route: 'deleteNotification', notification: this.state.deleting }))
    }
    cancel = (e) => {
        this.setState({ adding: false, uploading: false, editing: false, deleting: false, loading: false, wizard: false })
    }

    wisNav = (page) => (e) => {
        if (page > 0 && this.state.editing.name.length < 1) {
            this.setState({ wizard: 0, error: 'Please add a notification name before proceeding.', loading: false })
        } else if (page > 1 && !this.state.editing.file) {
            this.setState({ wizard: 1, error: 'Please select a file before proceeding.', loading: false })
        } else if (page > 2 && !this.state.editing.call.enabled && !this.state.editing.sms.enabled && !this.state.editing.email.enabled) {
            this.setState({ wizard: 2, error: 'Please select a contact method before proceeding.', loading: false })
        } else if (page > 2 && ((this.state.editing.call.enabled && !this.state.editing.call.field) || (this.state.editing.sms.enabled && !this.state.editing.sms.field) || (this.state.editing.email.enabled && !this.state.editing.email.field))) {
            this.setState({ wizard: 2, error: 'Please select a contact list field for each selected contact method before proceeding.', loading: false })
        } else if (page > 3 && this.state.editing.call.body.English.length < 1) {
            this.setState({ wizard: 3, error: 'Please enter a message body before proceeding.', loading: false })
        } else if (page > 4 && this.state.editing.sendOnTime === false && this.state.editing.sendUseVariable === false) {
            this.setState({ wizard: 4, error: 'Please choose a send date/time/method before proceeding.', loading: false })
        } else {
            this.setState({ wizard: page, error: '', loading: false })
        }
    }

    toggleNotification = (template) => (e) => {
        e.stopPropagation()
        this.props.ws.send(JSON.stringify({ route: 'toggleNotification', notification: template }))

    }
    expandClick = (page, expanded) => (e) => {
        this.expand(page, expanded)
    }
    expand = (page, expanded) => {
        var expandNow = {}
        var expandLater = {}                                           // expandLater kicks off in .5s to allow time for animation

        if (expanded) {
            expandNow[page] = false                                     //false = in the process of expanding
            expandLater[page] = true                                    //true = fully expanded
        }
        this.setState({ expand: expandNow })
        setTimeout(() => {
            this.setState({ expand: expandLater })
        }, 300)
    }
    valueChange = (param) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing[param] = e.currentTarget.value
        this.setState({ editing: editing })
    }
    callValueChange = (param) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.call[param] = e.currentTarget.value
        this.setState({ editing: editing })
    }
    smsResponseTimeout = (param) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.sms[param] = e.currentTarget.value * 60000
        this.setState({ editing: editing })
    }
    emailResponseTimeout = (param) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.email[param] = e.currentTarget.value * 60000
        this.setState({ editing: editing })
    }
    adjustRetryInterval = (param) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.call[param] = e.currentTarget.value * 60000
        this.setState({ editing: editing })
    }
    editAllBody = (language) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.call.body[language] = e.currentTarget.value
        editing.sms.body[language] = e.currentTarget.value
        editing.email.body[language] = e.currentTarget.value
        this.setState({ editing: editing })
    }
    editOneBody = (media, language) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing[media].body[language] = e.currentTarget.value
        this.setState({ editing: editing })
    }
    editSubject = (media, language) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing[media].subject[language] = e.currentTarget.value
        this.setState({ editing: editing })
    }

    editVerbiage = (field, index) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing[field][index] = e.currentTarget.value
        this.setState({ editing: editing })
    }
    superSelect = (param) => (sel) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing[param] = sel ? sel.id : null
        this.setState({ editing: editing })
    }
    selectFile = (sel) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.file = sel ? sel.id : undefined
        var file = sel ? this.props.data.Contacts[sel.id] : undefined
        this.setState({ file: file, editing: editing })
    }
    selectMediaType = (type) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing[type].enabled = editing[type].enabled ? false : true
        this.setState({ editing: editing })
    }
    setScheduleMethod = (method) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))

        editing.scheduling.now = false
        editing.scheduling.onReceipt = false
        editing.scheduling.time = null
        editing.scheduling.variable = null
        editing.scheduling.escalation = false

        editing.scheduling[method] = true

        this.setState({ editing: editing })
    }
    selectSendTime = (sendUseVariable, sendOnTime) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.sendUseVariable = sendUseVariable
        editing.sendOnTime = sendOnTime ? sendOnTime : false
        this.setState({ editing: editing })
    }
    selectSimpleSendTime = (sendOnTime) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.scheduling.time = sendOnTime ? sendOnTime : editing.sendOnTime
        this.setState({ editing: editing })
    }
    selectSendVariable = (variable) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.scheduling.variable = variable ? variable.id : ""
        this.setState({ editing: editing })
    }
    selectOffsetDirection = (direction) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        if (direction && direction.id == 'before') {
            editing.scheduling.offset.value = 0 - Math.abs(editing.scheduling.offset.value)
        } else if (direction && direction.id == 'after') {
            editing.scheduling.offset.value = 0 + Math.abs(editing.scheduling.offset.value)
        } else {
            editing.scheduling.offset.value = 0
        }
        this.setState({ editing: editing })
    }
    selectOffsetUnit = (unit) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.scheduling.offset.unit = unit ? unit.id : ""
        this.setState({ editing: editing })
    }
    selectOffsetValue = (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        if (editing.scheduling.offset.value < 0) {
            editing.scheduling.offset.value = 0 - Math.abs(e.currentTarget.value)
        } else if (editing.scheduling.offset.value > 0) {
            editing.scheduling.offset.value = 0 + Math.abs(e.currentTarget.value)
        } else {
            editing.scheduling.offset.value = e.currentTarget.value
        }


        this.setState({ editing: editing })
    }
    selectOutboundPhone = (phone) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.call.localAddress = phone ? phone.id : editing.call.localAddress
        this.setState({ editing: editing })
    }
    selectPhoneSurvey = (phone) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.call.survey = phone ? phone.id : null
        editing.call.surveyTitle = phone ? phone.name : null
        this.setState({ editing: editing })
    }


    selectSMSSurvey = (survey) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.sms.survey = survey ? survey.id : null
        editing.sms.surveyTitle = survey ? survey.name : null
		editing.sms.messagingService = survey ? this.props.data.Notifications.outboundSurveyMessagingService :  this.props.data.Notifications.outboundNotificationMessagingService
        this.setState({ editing: editing })
    }
    selectOutboundEmail = (email) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.email.localAddress = email ? email.id : editing.email.localAddress
        this.setState({ editing: editing })
    }
    selectCustomFlow = (flow) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.call.customFlow = flow ? flow.id : editing.call.customFlow
        this.setState({ editing: editing })
    }

    selectSendField = (mediaType) => (variable) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing[mediaType].field = variable ? variable.id : editing[mediaType].field
        this.setState({ editing: editing })
    }

    toggle = (value) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing[value] = editing[value] ? false : true
        this.setState({ editing: editing })
    }
    toggleCustomFlow = (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.call.customFlow = editing.call.customFlow ? null : true
        this.setState({ editing: editing })
    }
    togglePreconfirm = (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.call.preConfirm.enabled = editing.call.preConfirm.enabled ? false : true
        this.setState({ editing: editing })
    }
    toggleOverride = (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.scheduling.override = editing.scheduling.override ? false : true
        this.setState({ editing: editing })
    }

    toggleMidnightClear = (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.scheduling.midnightClear = editing.scheduling.midnightClear ? false : true
        this.setState({ editing: editing })
    }
    toggleRepeat = (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.call.repeat = editing.call.repeat ? false : true
        this.setState({ editing: editing })
    }
    editPreConfirm = (lang) => (e) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))

        editing.call.preConfirm.message[lang] = e.currentTarget.value

        this.setState({ editing: editing })
    }
    confirmNotification = (e) => {
        if (!this.state.activeNotification.templateName || this.state.activeNotification.templateName.length < 1) {
            this.setState({ activeNotificationError: 'Please Provide a Notification Name.' })
        } else if (!this.state.activeNotification.file) {
            this.setState({ activeNotificationError: 'Please Select a Contact List for This Notification.' })
        } else if (!this.state.activeNotification.actions || this.state.activeNotification.actions.length < 1) {
            this.setState({ activeNotificationError: 'Please Add at Least One Action for This Notification.' })
        } else {
            this.setState({ loading: true });
            this.props.ws.send(JSON.stringify({ route: 'addNotification', activeNotification: this.state.activeNotification }))
        }
    }


    addLanguage = (newLang) => {
        var newValue = JSON.parse(JSON.stringify(this.state.editing))

        newValue.call.body[newLang.id] = ""
        newValue.call.preConfirm.message[newLang.id] = ""
        newValue.email.body[newLang.id] = ""
        newValue.email.subject[newLang.id] = ""
        newValue.sms.body[newLang.id] = ""
        newValue.call.body[newLang.id] = ""

        this.setState({ editing: newValue, error: '', loading: false })
    }
    removeLanguage = (lang) => (e) => {
        var newValue = JSON.parse(JSON.stringify(this.state.editing))

        delete newValue.call.body[lang]
        delete newValue.call.preConfirm.message[lang]
        delete newValue.email.body[lang]
        delete newValue.email.subject[lang]
        delete newValue.sms.body[lang]
        delete newValue.call.body[lang]

        newValue.defaultLanguage = Object.keys(newValue.call.body)[0]

        this.setState({ editing: newValue, error: '', loading: false })
    }
    selectLanguageField = (sel) => {
        var editing = JSON.parse(JSON.stringify(this.state.editing))
        editing.languageVariable = sel ? sel.id : undefined
        this.setState({ editing: editing })
    }
    addNewConditionVariable = (field) => {
        if (field) {
            var newValue = JSON.parse(JSON.stringify(this.state.editing))
            if (field.id == 'Location') {
                newValue.conditions.push({ comparison: '=', value: [], variable: field.id })
            } else {
                newValue.conditions.push({ comparison: null, value: null, variable: field.id })
            }

            this.setState({ editing: newValue })
        }
    }
    selectConditionVariable = (index) => (field) => {
        var newValue = JSON.parse(JSON.stringify(this.state.editing))

        if (field.id == 'Location') {
            newValue.conditions[index].comparison = '='
            newValue.conditions[index].value = []
        }

        newValue.conditions[index].variable = field ? field.id : null

        this.setState({ editing: newValue })
    }
    removeCondition = (index) => (e) => {
        console.log(index, e)
        var newValue = JSON.parse(JSON.stringify(this.state.editing))
        newValue.conditions.splice(index, 1)
        this.setState({ editing: newValue })
    }
    selectConditionComparison = (index) => (comp) => {
        var newValue = JSON.parse(JSON.stringify(this.state.editing))

        if (comp && comp.id) {
            newValue.conditions[index].comparison = comp.id
        } else {
            delete newValue.conditions[index].comparison
        }

        this.setState({ editing: newValue })
    }
    editConditionValue = (index) => (e) => {
        var newValue = JSON.parse(JSON.stringify(this.state.editing))
        newValue.conditions[index].value = e.currentTarget.value
        this.setState({ editing: newValue })
    }
    selectConditionLocation = (index) => (location) => {
        if (location) {
            var newState = JSON.parse(JSON.stringify(this.state.editing))
            newState.conditions[index].value = location.map((loc) => { return loc.name })
            this.setState({ editing: newState })
        }
    }
    sort = (sortBy) => (e) => {
        var sortOrder
        if (this.state.sortOrder === -1) {
            sortOrder = 1;
        } else {
            sortOrder = -1;
        }
        this.setState({ sortBy: sortBy, sortOrder: sortOrder })
    }

    filter = (e) => {
        var filterBy = this.state.filterBy
        if (e.target.value.length > 0) {
            filterBy[e.target.getAttribute("data-filterby")] = e.target.value
        } else {
            delete filterBy[e.target.getAttribute("data-filterby")]
        }
        this.setState({ filterBy: filterBy })
    }

    filterByDropdown = (value) => {
        var filterBy = this.state.filterBy
        if (!value) {
            delete filterBy.active
        } else if (value.id == 1) {
            filterBy.active = true
        } else if (value.id == 0) {
            filterBy.active = false
        }
        this.setState({ filterBy: filterBy })

    }
    sortFunc(sortBy, sortOrder) {
        return function (a, b) {
            if (sortBy in a && sortBy in b) {
                if (a[sortBy] === b[sortBy]) {
                    return a.name > b.name ? 1 * sortOrder : -1 * sortOrder
                }
                return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
            }
            else if (!(sortBy in a) && !(sortBy in b)) {
                return a.name > b.name ? 1 * sortOrder : -1 * sortOrder
            } else {
                return sortBy in a ? -1 : 1
            }
        }
    }

    filterFunc(array, filterBy, module) {

        return array.filter(function (object) {
            for (var prop in filterBy) {
                if (typeof object[prop] === "undefined") {
                    return false

                }
                if (prop == 'file') {
                    if (module.props.data.Contacts[object[prop]].filename.toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                        return false
                    }
                } else if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                    return false

                }
            }
            return true
        })
    }

    drag = (e) => {
        e.dataTransfer.setData("text", " {" + e.target.innerHTML + "} ");
    }

    actionMethodSelect = (sel) => {
        if (sel) {
            var activeAction = Object.assign({}, this.state.activeAction)
            activeAction.method = sel.name
            this.setState({ activeAction: activeAction })
        }
    }

    actionUnitSelect = (sel) => {
        if (sel) {
            var activeAction = Object.assign({}, this.state.activeAction)
            activeAction.unit = sel.name
            this.setState({ activeAction: activeAction })
        }
    }
    actionTimingSelect = (sel) => {
        if (sel) {
            var activeAction = Object.assign({}, this.state.activeAction)
            activeAction.timing = sel.name
            this.setState({ activeAction: activeAction })
        }
    }
    actionVariableSelect = (sel) => {
        if (sel) {
            var activeAction = Object.assign({}, this.state.activeAction)
            activeAction.variable = sel.name
            this.setState({ activeAction: activeAction })
        }
    }

    updateSliderLabels = (e) => {
        var activeAction = Object.assign({}, this.state.activeAction)

        activeAction.sendWindows = e
        this.setState({ activeAction: activeAction })
    }
    convertTime(time) {
        var result = new Date()
        result.setHours(0)
        result.setMinutes(0)
        result.setSeconds(time)

        return result.toLocaleTimeString().replace(":00 ", " ")
    }
    nextHour(dt) {
        var newDt = new Date(new Date().getTime() + 7200000)
        newDt.setMinutes(0)
        newDt.setSeconds(0)

        return newDt
    }
    componentWillReceiveProps(nextProps) {
        if (this.state.loading) {
            this.cancel()
        }
    }

    render() {
        var header
        if (this.props.active) {
            var notificationArray = Object.values(this.props.data.Notifications.templates)

            //Filtering Notification List
            var notifications
            if (Object.keys(this.state.filterBy).length > 0) {
                notifications = this.filterFunc(notificationArray.slice(), this.state.filterBy, this)
            } else {
                notifications = notificationArray.slice()
            }

            //Sorting filtered Notification List
            if (this.state.sortBy !== '') {
                notifications.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
            }

            //Listing out templates
            var notificationList = []
            if (notifications.length > 0) {
                for (var [i, notification] of notifications.entries()) {
                    notificationList.push(
                        <div className="dataRow" tabIndex={1000 + i} key={notification.id} onClick={this.edit(notification)}>
                            <div className="activeBox" onClick={this.toggleNotification(notification)}>
                                <div className={notification.active ? "enabled" : "disabled"}></div>
                            </div>
                            <span style={{ marginLeft: '10px', flex: '1 0 200px' }}>{notification.name}</span>
                            <span style={{ marginLeft: '10px', flex: '1 0 200px' }}>{this.props.data.Contacts[notification.file] ? this.props.data.Contacts[notification.file].filename : 'No File Found'}</span>
                            <span className="buttonBox">
                                <img src={this.props.img.delete} alt="delete" onClick={this.delete(notification)} />
                            </span>
                        </div>
                    )
                }
            } else {
                notificationList.push(
                    <div key={"No Notifications"} onClick={this.addNotification}>
                        No notifications. Click to add one now or adjust your filter criteria.
					</div>
                )
            }
            var scheduledNotificationList = []
            if (notificationArray.length > 0) {
                for (var [i, notification] of notificationArray.entries()) {
                    scheduledNotificationList.push(
                        <div className="dataRow" tabIndex={1000 + i} key={notification.id} onClick={this.edit(notification)}>
                            <div className="activeBox" onClick={this.toggleNotification(notification)}>
                                <div className={notification.active ? "enabled" : "disabled"}></div>
                            </div>
                            <span style={{ marginLeft: '10px', flex: '1 0 200px' }}>{notification.name}</span>
                            <span style={{ marginLeft: '10px', flex: '1 0 200px' }}>{this.props.data.Contacts[notification.file] ? this.props.data.Contacts[notification.file].filename : 'No File Found'}</span>
                            <span className="buttonBox">
                                <img src={this.props.img.delete} alt="delete" onClick={this.delete(notification)} />
                            </span>
                        </div>
                    )
                }
            } else {
                scheduledNotificationList.push(
                    <div onClick={this.addNotification}>
                        No notifications are scheduled at this time. Click to add one now.
					</div>
                )
            }
            var add = ""
            if (this.state.adding) {
                add = (
                    <div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
                        <div className="pop">
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div>Create a New Notification or <br /> Upload New Contact List?</div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ margin: '15px', padding: '5px', cursor: 'pointer' }} onClick={this.startWizard}>
                                    <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueBell} />
                                    <div>Notification</div>
                                </div>
                                <div style={{ margin: '15px', padding: '5px', cursor: 'pointer' }} onClick={this.startFileUpload}>
                                    <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueFile} />
                                    <div>Contact List</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            var upload = ""
            if (this.state.uploading) {
                upload = (
                    <div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
                        <div className="pop">
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div>Upload a New .csv File Contact List</div>
                            <br /><br />
                            <input style={{ width: '0.1px', height: '0.1px', opacity: '0', overflow: 'hidden', position: 'absolute', zIndex: '-1' }} type="file" id="wav" onChange={this.setFileName} />

                            {this.state.contactList ?
                                <div >
                                    <label style={{ display: 'inline-block', border: '1px solid #379', borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }} className="button" htmlFor="wav">Browse
                                    </label>

                                    <span style={{ display: 'inline-block', border: '1px solid #379', padding: '15px 29px', fontSize: '25px' }}>{this.state.contactList.name.split('\\')[this.state.contactList.name.split('\\').length - 1]}
                                    </span>

                                </div>
                                : <label className="button" htmlFor="wav">Browse</label>
                            }

                            <div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

                            {this.state.binaryData ? this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmContactUpload}>Upload</div> : ''}
                        </div>
                    </div>
                )
            }


            var selectProps = { placeholder: "Select a Contact List" }
            if (this.state.editing && this.state.editing.file) {
                selectProps.initialValue = { id: this.state.editing.file, name: this.props.data.Contacts[this.state.editing.file].filename }
            }
            if (this.state.file) {
                var headers = []
                var headerList = []
                var selectedLanguageField
                for (header of this.state.file.headers) {
                    if (this.state.editing.languageVariable === header) {
                        selectedLanguageField = { id: header, name: header }
                    }

                    headers.push({ id: header, name: header })
                    headerList.push(
                        <div draggable="true" style={{ flex: '1 1 100px', padding: '5px 10px', border: '1px solid #379', display: 'inline', cursor: 'grab' }} onDragStart={this.drag} key={header}>{header}</div>
                    )


                }
                headerList = (
                    <div style={{ display: 'flex', flexFlow: 'row wrap', maxWidth: '85vw' }}>
                        {headerList}
                    </div>
                )
            }

            var wizard = ""
            var displayMethods = {
                sms: 'SMS',
                phone: 'Phone',
                email: 'Email',
                push: 'Push'
            }
            var files = []
            for (var file in this.props.data.Contacts) {
                files.push({ id: file, name: this.props.data.Contacts[file].filename })
            }

            files.sort((a, b) => {
                return (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
            })


            if (this.state.editing && this.state.wizard !== false) {
                wizard = [
                    (<div className="blackout"> {
                    }
                        <div className="pop" style={{ overflow: 'visible' }}>
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div>What should the name of the new notification be?</div>

                            <div className="snazzyInputBox" style={{ marginTop: '50px' }}>
                                <input className="textInput" type="text" required value={this.state.editing.name} onChange={this.valueChange('name')} ></input>
                                <span className="inputBar"></span><label className="textLabel">Notification Name</label>
                            </div>
                            <div className="error" style={{ margin: '0px auto 0px auto' }}>{this.state.error}</div>
                            {this.state.loading ? <div className="loader" style={{ margin: '10px auto 0px auto' }}></div> : <div className="button" style={{ margin: '5px auto 0px auto' }} onClick={this.wisNav(1)}>Next</div>}
                        </div>
                    </div>),
                    (<div className="blackout">
                        <div className="pop" style={{ overflow: 'visible' }}>
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div style={{ flex: '1 0 150px', margin: '10px' }}>Which contact list should the notification be based on?</div>
                            <div style={{ flex: '1 0 150px', margin: '10px' }} >(This can't be changed once selected.)</div>

                            <ReactSuperSelect style={{ flex: '1 0 150px', margin: '0px' }} {...selectProps} dataSource={files} onChange={this.selectFile} />

                            <div className="error" style={{ margin: '0px auto 0px auto' }}>{this.state.error}</div>
                            {this.state.loading ? <div className="loader" style={{ margin: '30px auto 0px auto' }}></div> : <div style={{ margin: '30px auto 0px auto', display: 'flex' }}><div className="button" style={{ backgroundColor: '#888' }} onClick={this.wisNav(0)}>Back</div> <div className="button" onClick={this.wisNav(2)}>Next</div></div>}
                        </div>
                    </div>),
                    (<div className="blackout">
                        <div className="pop" style={{ overflow: 'visible' }}>
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div>What type of notification should be sent?</div>

                            <div style={{ display: 'flex', width: '75vw', justifyContent: 'space-between' }}>
                                <div style={{ flex: '1 0 25%', margin: '15px', border: this.state.editing.call.enabled ? '2px solid #2A6AA9' : '2px solid #FFFFFF', padding: '5px', cursor: 'pointer' }}>
                                    <div onClick={this.selectMediaType('call')}>
                                        <img style={{ margin: '15px', height: '80px' }} src={this.props.img.bluePhone} />
                                        <div>Call</div>
                                    </div>
                                    {this.state.editing.call.enabled ?
                                        <div style={{ padding: '15px' }}>
                                            {<ReactSuperSelect placeholder="Column" clearable={false} dataSource={headers} initialValue={this.state.editing.call.field ? { id: this.state.editing.call.field, name: this.state.editing.call.field } : null} onChange={this.selectSendField('call')} />}
                                        </div>
                                        : ''}
                                </div>
                                <div style={{ flex: '1 0 25%', margin: '15px', border: this.state.editing.sms.enabled ? '2px solid #2A6AA9' : '2px solid #FFFFFF', padding: '5px', cursor: 'pointer' }}>
                                    <div onClick={this.selectMediaType('sms')}>
                                        <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueSMS} />
                                        <div>SMS</div>
                                    </div>
                                    {this.state.editing.sms.enabled ?
                                        <div style={{ padding: '15px' }}>
                                            {<ReactSuperSelect placeholder="Column" clearable={false} dataSource={headers} initialValue={this.state.editing.sms.field ? { id: this.state.editing.sms.field, name: this.state.editing.sms.field } : null} onChange={this.selectSendField('sms')} />}
                                        </div>
                                        : ''}
                                </div>
                                <div style={{ flex: '1 0 25%', margin: '15px', border: this.state.editing.email.enabled ? '2px solid #2A6AA9' : '2px solid #FFFFFF', padding: '5px', cursor: 'pointer' }}>
                                    <div onClick={this.selectMediaType('email')}>
                                        <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueEmail} />
                                        <div>Email</div>
                                    </div>
                                    {this.state.editing.email.enabled ?
                                        <div style={{ padding: '15px' }}>
                                            {<ReactSuperSelect placeholder="Column" clearable={false} dataSource={headers} initialValue={this.state.editing.email.field ? { id: this.state.editing.email.field, name: this.state.editing.email.field } : null} onChange={this.selectSendField('email')} />}
                                        </div>
                                        : ''}
                                </div>
                            </div>

                            <div className="error" style={{ margin: '0px auto 0px auto' }}>{this.state.error}</div>
                            {this.state.loading ? <div className="loader" style={{ margin: '30px auto 0px auto' }}></div> : <div style={{ margin: '30px auto 0px auto', display: 'flex' }}><div className="button" style={{ backgroundColor: '#888' }} onClick={this.wisNav(1)}>Back</div> <div className="button" onClick={this.wisNav(3)}>Next</div></div>}
                        </div>
                    </div>),
                    (<div className="blackout">
                        <div className="pop" style={{ overflow: 'visible' }}>
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div>What should the notification say?</div>

                            <div className="snazzyInputBox">
                                <textarea className="bigTextInput" required value={this.state.editing.call.body.English} onChange={this.editAllBody('English')} ></textarea>
                                <label className="textLabel">Message Verbiage</label>
                                <div style={{ textAlign: 'right', paddingRight: '15px', top: '-15px', fontSize: '14px', position: 'relative' }}>{this.state.editing.call.body.English ? this.state.editing.call.body.English.length : ''}</div>
                            </div>
                            {headerList}
                            <div className="error" style={{ margin: '0px auto 0px auto' }}>{this.state.error}</div>
                            {this.state.loading ? <div className="loader" style={{ margin: '30px auto 0px auto' }}></div> : <div style={{ margin: '30px auto 0px auto', display: 'flex' }}><div className="button" style={{ backgroundColor: '#888' }} onClick={this.wisNav(2)}>Back</div> <div className="button" style={{ backgroundColor: '#888' }} onClick={this.wisNav(false)}>Advanced</div> <div className="button" onClick={this.wisNav(4)}>Next</div></div>}
                        </div>
                    </div>),
                    (<div className="blackout">
                        <div style={{ overflow: "visible" }} className="pop">
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div>When should the notification be sent?</div>

                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ margin: '15px', border: this.state.editing.scheduling.now === true ? '2px solid #2A6AA9' : '2px solid #FFFFFF', background: this.state.editing.scheduling.now === true ? 'radial-gradient(#cee 0%, #fff 70%, #fff 100%)' : '#fff', padding: '5px', cursor: 'pointer' }} onClick={this.setScheduleMethod('now')}>
                                    <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueLightning} />
                                    <div>Now</div>
                                </div>

                                <div style={{ margin: '15px', border: this.state.editing.scheduling.onReceipt ? '2px solid #2A6AA9' : '2px solid #FFFFFF', background: this.state.editing.scheduling.onReceipt ? 'radial-gradient(#cee 0%, #fff 70%, #fff 100%)' : '#fff', padding: '5px', cursor: 'pointer' }} onClick={this.setScheduleMethod('onReceipt')}>
                                    <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueReceipt} />
                                    <div>On Contact List Receipt</div>
                                </div>

                                <div style={{ margin: '15px', border: this.state.editing.scheduling.time ? '2px solid #2A6AA9' : '2px solid #FFFFFF', background: this.state.editing.scheduling.time ? 'radial-gradient(#cee 0%, #fff 70%, #fff 100%)' : '#fff', padding: '5px', cursor: 'pointer' }} onClick={this.setScheduleMethod('time')}>
                                    <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueCalendar} />
                                    <div>Schedule</div>
                                </div>

                                <div style={{ margin: '15px', border: this.state.editing.scheduling.variable ? '2px solid #2A6AA9' : '2px solid #FFFFFF', background: this.state.editing.scheduling.variable ? 'radial-gradient(#cee 0%, #fff 70%, #fff 100%)' : '#fff', padding: '5px', cursor: 'pointer' }} onClick={this.setScheduleMethod('variable')}>
                                    <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueFile} />
                                    <div>Date From File</div>
                                </div>
                                {false ?
                                    <div style={{ margin: '15px', border: this.state.editing.scheduling.escalation ? '2px solid #2A6AA9' : '2px solid #FFFFFF', background: this.state.editing.scheduling.escalation ? 'radial-gradient(#cee 0%, #fff 70%, #fff 100%)' : '#fff', padding: '5px', cursor: 'pointer' }} onClick={this.setScheduleMethod('escalation')}>
                                        <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueStairsUp} />
                                        <div>Escalation</div>
                                    </div>
                                    : ''}
                            </div>

                            {this.state.editing.scheduling.now === true ?
                                <div>
                                    The notification will be sent immediately after confirmation.
                            </div>
                                : ''}

                            {this.state.editing.scheduling.onReceipt ?
                                <div>
                                    The notification will be sent whenever a new contact list is received.
                            </div>
                                : ''}

                            {this.state.editing.scheduling.time ?
                                <div style={{ maxWidth: '500px' }}>
                                    <div>Send Date and Time:</div>
                                    <Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: 'calc(100% - 40px)', margin: '5px' }} options={{ dateFormat: "Y-m-d h:i K" }} data-enable-time value={this.state.editing.scheduling.time} onChange={date => { this.selectSimpleSendTime(date[0]) }} />
                                </div>
                                : ''}

                            {this.state.editing.scheduling.variable ?
                                <div style={{ maxWidth: '500px' }}>
                                    <div>Choose Date Column:</div>
                                    {<ReactSuperSelect style={{ flex: '1 0 150px', margin: '0px' }} dataSource={headers} initialValue={this.state.editing.sendVariable} onChange={this.selectSendVariable} />}
                                </div>
                                : ''}

                            {this.state.editing.scheduling.escalation ?
                                <div>
                                    This notification will be sent to contacts who fail to meet acknowledgement criteria.
                            </div>
                                : ''}

                            <div className="error" style={{ margin: '0px auto 0px auto' }}>{this.state.error}</div>
                            {this.state.loading ? <div className="loader" style={{ margin: '30px auto 0px auto' }}></div> : <div style={{ margin: '30px auto 0px auto', display: 'flex' }}><div className="button" style={{ backgroundColor: '#888' }} onClick={this.wisNav(3)}>Back</div> <div className="button" style={{ backgroundColor: '#888' }} onClick={this.wisNav(false)}>Advanced</div> <div className="button" onClick={this.wisNav(5)}>Next</div></div>}
                        </div>
                    </div>),
                    (<div className="blackout">
                        <div className="pop" style={{ overflow: 'visible', textAlign: 'left', width: '500px' }}>
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div style={{ textAlign: 'center', width: '500px' }}>Confirm the details for the notification.</div>

                            <div style={{ display: 'flex', margin: '10px', cursor: 'pointer' }} onClick={this.wisNav(0)}>
                                <div style={{ flex: '1 0 50%' }}>Notification Name:</div>
                                <div style={{ flex: '2 0 50%', color: '#333' }}>{this.state.editing.name}</div>
                            </div>
                            <div style={{ display: 'flex', margin: '10px', cursor: 'pointer' }} onClick={this.wisNav(1)}>
                                <div style={{ flex: '1 0 50%' }}>Linked to Contact List:</div>
                                <div style={{ flex: '2 0 50%', color: '#333' }}>{this.state.file ? this.state.file.filename : ''}</div>
                            </div>
                            <div style={{ display: 'flex', margin: '10px', cursor: 'pointer' }} onClick={this.wisNav(2)}>
                                <div style={{ flex: '1 0 50%' }}>Contact Method:</div>
                                <div style={{ flex: '2 0 50%', color: '#333' }}>{
                                    ((this.state.editing.call.enabled ? "Call, " : '') +
                                        (this.state.editing.sms.enabled ? "SMS, " : '') +
                                        (this.state.editing.email.enabled ? "Email, " : '')).replace(/, $/gm, '')
                                }</div>
                            </div>
                            <div style={{ display: 'flex', margin: '10px', cursor: 'pointer' }} onClick={this.wisNav(4)}>
                                <div style={{ flex: '1 0 50%' }}>Scheduling:</div>
                                <div style={{ flex: '2 0 50%', color: '#333' }}>{
                                    this.state.editing.scheduling.variable ? 'Based on {' + this.state.editing.scheduling.variable + '}' :
                                        this.state.editing.scheduling.now === true ? 'Send Now' :
                                            this.state.editing.scheduling.onReceipt ? 'Send whenever ' + this.state.file.filename + ' is received' :
                                                this.state.editing.scheduling.escalation ? 'Escalate from another template' :
                                                    new Date(this.state.editing.scheduling.time).toDateString().substring(4) + ', ' + new Date(this.state.editing.scheduling.time).toLocaleTimeString()

                                }</div>
                            </div>

                            <div style={{ textAlign: 'center', cursor: 'pointer' }} onClick={this.wisNav(3)}>Message Body:</div>
                            <div style={{ margin: '10px', color: '#333', cursor: 'pointer' }} onClick={this.wisNav(4)}>{this.state.editing.call.body.English}</div>


                            <div className="error" style={{ margin: '0px auto 0px auto' }}>{this.state.error}</div>

                            {this.state.loading ?
                                <div className="loader" style={{ margin: '30px auto 0px auto' }}></div> :
                                <div style={{ margin: '30px auto 0px auto', display: 'flex' }}>
                                    <div className="button" style={{ backgroundColor: '#888' }} onClick={this.wisNav(4)}>Back</div>
                                    <div className="button" style={{ backgroundColor: '#888' }} onClick={this.wisNav(false)}>Advanced</div>
                                    <div className="button" onClick={this.addNewNotification}>Confirm</div>
                                </div>}
                        </div>
                    </div>)
                ]
            }

            //Adding or Editing a notification, within a pop-up
            var activeNotification = ""
            if (this.state.editing && this.state.wizard === false) {
                var langArray = []
                var preConfirmArray = []
                var emailSubjectArray = []
                var callBodyArray = []
                var smsBodyArray = []
                var emailBodyArray = []
                var additionalLanguages = [
                    { id: 'Danish', name: 'Danish' },
                    { id: 'Dutch', name: 'Dutch' },
                    { id: 'English', name: 'English' },
                    { id: 'French', name: 'French' },
                    { id: 'German', name: 'German' },
                    { id: 'Icelandic', name: 'Icelandic' },
                    { id: 'Italian', name: 'Italian' },
                    { id: 'Japanese', name: 'Japanese' },
                    { id: 'Norwegian', name: 'Norwegian' },
                    { id: 'Polish', name: 'Polish' },
                    { id: 'Portuguese', name: 'Portuguese' },
                    { id: 'Romanian', name: 'Romanian' },
                    { id: 'Russian', name: 'Russian' },
                    { id: 'Spanish', name: 'Spanish' },
                    { id: 'Swedish', name: 'Swedish' },
                    { id: 'Turkish', name: 'Turkish' },
                    { id: 'Welsh', name: 'Welsh' }
                ]
                var conditionArray = []

                Object.keys(this.state.editing.call.body).forEach((lang, index) => {
                    langArray.push(
                        <div style={{ flex: '0 0 20%', lineHeight: '40px', position: 'relative' }} key={index}>
                            {lang}
                            {Object.keys(this.state.editing.call.body).length > 1 ? <div style={{ position: 'absolute', top: '0px', right: '8px' }} onClick={this.removeLanguage(lang)}>X</div> : ''}
                        </div>
                    )
                    preConfirmArray.push(
                        <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }} key={index}>
                            <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>{lang + " Confirmation"}</div>
                            <input style={{ flex: '1 0 20%', margin: '10px 15px' }} onChange={this.editPreConfirm(lang)} className="textInput" type="text" required value={this.state.editing.call.preConfirm.message[lang]} ></input>

                        </div>
                    )
                    emailSubjectArray.push(
                        <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }} key={index}>
                            <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>{lang + " Subject"}</div>
                            <input style={{ flex: '1 0 20%', margin: '10px 15px' }} onChange={this.editSubject('email', lang)} className="textInput" type="text" required value={this.state.editing.email.subject[lang]} ></input>

                        </div>
                    )
                    callBodyArray.push(
                        <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }} key={index}>
                            <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>{lang + " Message"}</div>
                            <textarea style={{ flex: '1 0 20%', margin: '10px 15px' }} onChange={this.editOneBody('call', lang)} className="bigTextInput" type="text" required value={this.state.editing.call.body[lang]} ></textarea>

                        </div>
                    )
                    smsBodyArray.push(
                        <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }} key={index}>
                            <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>{lang + " Message"}</div>
                            <textarea style={{ flex: '1 0 20%', margin: '10px 15px' }} onChange={this.editOneBody('sms', lang)} className="bigTextInput" type="text" required value={this.state.editing.sms.body[lang]} ></textarea>

                        </div>
                    )
                    emailBodyArray.push(
                        <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }} key={index}>
                            <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>{lang + " Body"}</div>
                            <textarea style={{ flex: '1 0 20%', margin: '10px 15px' }} onChange={this.editOneBody('email', lang)} className="bigTextInput" type="text" required value={this.state.editing.email.body[lang]} ></textarea>

                        </div>
                    )

                    additionalLanguages = additionalLanguages.filter((newLang) => {
                        return !this.state.editing.call.body.hasOwnProperty(newLang.id)
                    })
                })

                var availableConditionHeaders = headers.filter((header) => {
                    for (condition of this.state.editing.conditions) {
                        if (header.name == condition.variable) {
                            return false
                        }
                    }
                    return true
                })
                for (var [index, condition] of this.state.editing.conditions.entries()) {
                    if (this.state.editing.conditions[index].variable == 'Location' && this.state.editing.conditions[index].value) {
                        var initialValue = []

                        for (var location of this.state.editing.conditions[index].value) {
                            initialValue.push({ id: location, name: location })
                        }
                    }
                    var availableConditionHeadersPlus = availableConditionHeaders.splice().unshift({ id: this.state.editing.conditions[index].variable, name: this.state.editing.conditions[index].variable })
                    conditionArray.push(
                        <div style={{ display: 'flex', justifyContent: 'start', padding: '10px 0px' }}>
                            <div onClick={this.removeCondition(index)} style={{ padding: '0px 10px', fontSize: '30px', flex: ' 0 0 1%', color: '#937', lineHeight: '40px' }}>
                                x
                            </div>
                            <div style={{ flex: ' 1 1 30%' }}>
                                <ReactSuperSelect placeholder="Field" clearable={false} closeOnSelectedOptionClick={false} dataSource={availableConditionHeaders} initialValue={{ id: condition.variable, name: condition.variable }} onChange={this.selectConditionVariable(index)} />
                            </div>
                            {this.state.editing.conditions[index].variable ?
                                this.state.editing.conditions[index].variable == 'Location' ?

                                    <div style={{ flex: ' 1 1 30%', lineHeight: '40px' }} >Contains one or more of</div>
                                    :
                                    <div style={{ flex: ' 1 1 30%' }}>
                                        <ReactSuperSelect placeholder="Field" clearable={false} closeOnSelectedOptionClick={false} dataSource={[{ id: '=', name: '=' }, { id: '≠', name: '≠' }, { id: '<', name: '<' }, { id: '>', name: '>' }]} initialValue={{ id: condition.comparison, name: condition.comparison }} onChange={this.selectConditionComparison(index)} />
                                    </div>
                                : ''}




                            {this.state.editing.conditions[index].comparison ?
                                this.state.editing.conditions[index].variable == 'Location' ?
                                    <div style={{ flex: ' 0 0 30%' }}>
                                        <ReactSuperSelect clearable={false} initialValue={initialValue} closeOnSelectedOptionClick={false} customSelectedValueTemplateFunction={(selected) => { if (selected.length < 2) { return selected[0].name } else { return selected.length + " Locations Selected" } }} searchable={true} keepOpenOnSelection={true} multiple={true} placeholder="Select a Location" style={{ flex: '1 0 150px', margin: '0px' }} ajaxDataFetch={() => { return new Promise(async (res, rej) => { var response = await fetch(window.location.origin + '/locations'); if (response.ok) { res(await response.json()) }; }) }} onChange={this.selectConditionLocation(index)} />
                                    </div>


                                    : <input style={{ flex: '0 0 30%', margin: '0px 15px' }} onChange={this.editConditionValue(index)} className="textInput" type="text" required value={condition.value} ></input> : ''}
                        </div>
                    )
                }

                if (this.state.editing.conditions.length < 1 || this.state.editing.conditions[this.state.editing.conditions.length - 1].value) {
                    conditionArray.push(
                        <div style={{ flex: ' 0 0 30%', padding: '10px 0px' }}>
                            <ReactSuperSelect placeholder="Field" clearable={false} dataSource={availableConditionHeaders} onChange={this.addNewConditionVariable} />
                        </div>
                    )
                }

                if (additionalLanguages.length > 0) {
                    langArray.push(
                        <div style={{ flex: '0 0 20%', position: 'relative' }} key={Object.keys(this.state.editing.call.body).length}>
                            <ReactSuperSelect style={{ flex: '1 0 150px', margin: '0px' }} dataSource={additionalLanguages} placeholder="Add" onChange={this.addLanguage} />
                        </div>
                    )
                }
                if (this.state.editing.call.customFlow) {
                    var initialCustomFlow = null
                    for (var flow of this.props.data.Notifications.customFlows) {
                        if (this.state.editing.call.customFlow == flow.id) {
                            initialCustomFlow = flow
                        }
                    }
                }
                if (this.state.editing.call.localAddress) {
                    var initialOutboundPhone = { id: this.state.editing.call.localAddress, name: this.state.editing.call.localAddress }
                }
                if (this.state.editing.sms.localAddress) {
                    var initialOutboundSMS = this.state.editing.sms.messagingService ? { id: this.state.editing.sms.messagingService, name: this.state.editing.sms.messagingService } : { id: this.state.editing.sms.localAddress, name: this.state.editing.sms.localAddress }
                }

                activeNotification = (
                    <div className="blackout">
                        <div className="pop" style={{ width: '85%', maxHeight: '85vh' }}>
                            <div className="viewCloser" onClick={this.cancel}></div>

                            {this.state.expand.hasOwnProperty('notificationName') ?
                                <div className={this.state.expand.notificationName ? "expander expanded" : this.state.expand.notificationName === false ? "expander expanding" : "expander collapsing"}>

                                    <div className="dataHeaders" onClick={this.expandClick('notificationName', false)}>
                                        <div className="dataHeader">Notification Name: </div>
                                    </div>

                                    <div className="snazzyInputBox" style={{ maxWidth: 'none', margin: '0px auto' }}>
                                        <input className="textInput" type="text" required value={this.state.editing.name} onChange={this.valueChange('name')} ></input>
                                        <span className="inputBar"></span>
                                    </div>
                                </div>
                                :
                                <div className="expander" onClick={this.expandClick('notificationName', true)}>
                                    <div className="dataHeaders">
                                        <div className="dataHeader">Notification Name: </div>
                                        <div className="dataValue">{this.state.editing.name}</div>
                                    </div>
                                </div>
                            }


                            <div className="expander" onClick={this.expandClick('dataFile', true)}>
                                <div className="dataHeaders" style={{ cursor: 'arrow', backgroundColor: '#fff !IMPORTANT' }}>
                                    <div className="dataHeader">Linked Contact List: </div>
                                    <div className="dataValue"> {this.state.file.filename}</div>
                                </div>
                            </div>


                            {this.state.expand.hasOwnProperty('contactMethod') ?
                                <div className={this.state.expand.contactMethod ? "expander expanded" : this.state.expand.contactMethod === false ? "expander expanding" : "expander collapsing"}>
                                    <div className="dataHeaders" onClick={this.expandClick('contactMethod', false)}>
                                        <div className="dataHeader">Contact Method(s): </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ flex: '1 0 20%', margin: '15px', border: this.state.editing.call.enabled ? '2px solid #2A6AA9' : '2px solid #FFFFFF', padding: '5px', cursor: 'pointer' }}>
                                            <div onClick={this.selectMediaType('call')}>
                                                <img style={{ margin: '15px', height: '80px' }} src={this.props.img.bluePhone} />
                                                <div>Call</div>
                                            </div>
                                            {this.state.editing.call.enabled ?
                                                <div style={{ padding: '15px' }}>
                                                    {<ReactSuperSelect placeholder="Column" clearable={false} dataSource={headers} initialValue={this.state.editing.call.field ? { id: this.state.editing.call.field, name: this.state.editing.call.field } : null} onChange={this.selectSendField('call')} />}
                                                </div>
                                                : ''}
                                        </div>
                                        <div style={{ flex: '1 0 20%', margin: '15px', border: this.state.editing.sms.enabled ? '2px solid #2A6AA9' : '2px solid #FFFFFF', padding: '5px', cursor: 'pointer' }}>
                                            <div onClick={this.selectMediaType('sms')}>
                                                <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueSMS} />
                                                <div>SMS</div>
                                            </div>
                                            {this.state.editing.sms.enabled ?
                                                <div style={{ padding: '15px' }}>
                                                    {<ReactSuperSelect placeholder="Column" clearable={false} dataSource={headers} initialValue={this.state.editing.sms.field ? { id: this.state.editing.sms.field, name: this.state.editing.sms.field } : null} onChange={this.selectSendField('sms')} />}
                                                </div>
                                                : ''}
                                        </div>
                                        <div style={{ flex: '1 0 20%', margin: '15px', border: this.state.editing.email.enabled ? '2px solid #2A6AA9' : '2px solid #FFFFFF', padding: '5px', cursor: 'pointer' }}>
                                            <div onClick={this.selectMediaType('email')}>
                                                <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueEmail} />
                                                <div>Email</div>
                                            </div>
                                            {this.state.editing.email.enabled ?
                                                <div style={{ padding: '15px' }}>
                                                    {<ReactSuperSelect placeholder="Column" clearable={false} dataSource={headers} initialValue={this.state.editing.email.field ? { id: this.state.editing.email.field, name: this.state.editing.email.field } : null} onChange={this.selectSendField('email')} />}
                                                </div>
                                                : ''}
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="expander" onClick={this.expandClick('contactMethod', true)}>
                                    <div className="dataHeaders">
                                        <div className="dataHeader">Contact Method(s): </div>
                                        <div className="dataValue">{
                                            ((this.state.editing.call.enabled ? "Call, " : '') +
                                                (this.state.editing.sms.enabled ? "SMS, " : '') +
                                                (this.state.editing.email.enabled ? "Email, " : '')).replace(/, $/gm, '')
                                        }</div>
                                    </div>
                                </div>
                            }

                            {this.state.expand.hasOwnProperty('language') ?
                                <div className={this.state.expand.language ? "expander expanded" : "expander expanding"}>
                                    <div className="dataHeaders" onClick={this.expandClick('language', false)}>
                                        <div className="dataHeader">Language(s): </div>
                                    </div>
                                    <div style={{ display: 'flex', flexFlow: 'row wrap', alignContent: 'flex-start', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                                        {langArray}
                                    </div>

                                    {Object.keys(this.state.editing.call.body).length > 1 ?
                                        <div style={{ display: 'flex', padding: '25px 0px', flexFlow: 'row wrap', alignContent: 'flex-start', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                                            <div style={{ lineHeight: '40px', padding: '0px 15px' }}>Contact List Language Field:</div>

                                            {this.state.editing.languageVariable ?
                                                <ReactSuperSelect initialValue={selectedLanguageField} noResultsString="Please Select a File Above" style={{ flex: '1 0 150px', margin: '0px' }} dataSource={headers} onChange={this.selectLanguageField} />
                                                :
                                                <ReactSuperSelect noResultsString="Please Select a File Above" placeholder="Select the Language Field" style={{ flex: '1 0 150px', margin: '0px' }} dataSource={headers} onChange={this.selectLanguageField} />
                                            }

                                        </div>
                                        :
                                        <div style={{ paddingTop: '25px' }}>All Notifications will be sent in {Object.keys(this.state.editing.call.body)[0]}</div>
                                    }


                                </div>
                                :
                                <div className="expander" onClick={this.expandClick('language', true)}>
                                    <div className="dataHeaders">
                                        <div className="dataHeader">Language(s): </div>
                                        <div className="dataValue">{Object.keys(this.state.editing.call.body).join(', ') + ' | ' + (selectedLanguageField ? 'Language Field: ' + selectedLanguageField.name : "All Notifications will be sent in the same Language")}</div>
                                    </div>
                                </div>
                            }

                            {this.state.editing.call.enabled ?
                                this.state.expand.hasOwnProperty('phoneOptions') ?
                                    <div className={this.state.expand.phoneOptions ? "expander expanded" : "expander expanding"}>
                                        <div className="dataHeaders" onClick={this.expandClick('phoneOptions', false)}>
                                            <div className="dataHeader">Calls: </div>
                                        </div>

                                        {this.props.data.Notifications.customFlows && this.props.data.Notifications.customFlows.length > 0 ?
                                            <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }}>
                                                <div className="activeBox" style={{ margin: '12px 25px' }} onClick={this.toggleCustomFlow}>
                                                    <div className={this.state.editing.call.customFlow ? "enabled" : "disabled"}></div>
                                                </div>
                                                <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>Use Predefined Call Flow</div>
                                                {this.state.editing.call.customFlow ?
                                                    <div style={{ flex: '1 0 20%', margin: '10px 15px' }}>
                                                        <ReactSuperSelect dataSource={this.props.data.Notifications.customFlows} initialValue={initialCustomFlow} onChange={this.selectCustomFlow} />
                                                    </div>
                                                    : ''}
                                            </div>
                                            : ''}
                                        {!this.state.editing.call.customFlow ?
                                            <div>
                                                <div style={{ margin: '10px 25px', lineHeight: '32px' }}>{headerList}</div>
                                                <div>{callBodyArray}</div>
                                            </div>
                                            : ''}
                                        {!this.state.editing.call.customFlow ?
                                            <div style={{ display: 'flex', lineHeight: '40px' }}>
                                                <div className="activeBox" onClick={this.togglePreconfirm}>
                                                    <div className={this.state.editing.call.preConfirm.enabled ? "enabled" : "disabled"}></div>
                                                </div>
                                                <div>Enable Pre-message Confirmation {this.state.editing.call.preConfirm.enabled ? "(Instruct recipient to press any key.)" : ""}</div>
                                            </div>
                                            : ''}
                                        {!this.state.editing.call.customFlow && this.state.editing.call.preConfirm.enabled ?
                                            <div>
                                                <div>{preConfirmArray}</div>
                                            </div>
                                            : ''}

                                        <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }}>
                                            <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>Outbound Caller ID:</div>
                                            <div style={{ flex: '1 0 20%', margin: '10px 15px' }}>
                                                {<ReactSuperSelect ajaxDataFetch={() => { return new Promise(async (res, rej) => { var response = await fetch(window.location.origin + '/phoneNumbers'); if (response.ok) { res(await response.json()) }; }) }} initialValue={initialOutboundPhone} onChange={this.selectOutboundPhone} />}
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }}>
                                            <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>Select Phone Survey</div>

                                            <div style={{ flex: '1 0 20%', margin: '10px 15px' }}>
                                                <ReactSuperSelect ajaxDataFetch={() => { return new Promise(async (res, rej) => { var response = await fetch(window.location.origin + '/data?path=' + window.domain + ',Survey Management,data'); if (response.ok) { var ddArray = []; var ddItems = await response.json(); for (var ddItem in ddItems) { ddArray.push({ id: ddItems[ddItem].id, name: ddItems[ddItem].title }) }; res(ddArray) }; }) }} initialValue={{ id: this.state.editing.call.survey, name: this.state.editing.call.surveyTitle }} placeholder="No Survey Selected" onChange={this.selectPhoneSurvey} />
                                            </div>

                                        </div>
                                        {!this.state.editing.call.customFlow ?
                                            <div style={{ display: 'flex', lineHeight: '40px' }}>
                                                <div className="activeBox" onClick={this.toggleRepeat}>
                                                    <div className={this.state.editing.call.repeat ? "enabled" : "disabled"}></div>
                                                </div>
                                                <div>Enable Option to Repeat Message {this.state.editing.call.repeat ? "(Instruct recipient to press pound.)" : ""}</div>
                                            </div>
                                            : ''}
                                        {!this.state.editing.call.customFlow ?
                                            <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }}>
                                                <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>Maximum Retries:</div>
                                                <input style={{ flex: '1 0 20%', margin: '10px 15px' }} min="0" max="5" className="textInput" onChange={this.callValueChange('retryAttempts')} type="number" required value={this.state.editing.call.retryAttempts} ></input>
                                            </div>
                                            : ''}
                                        {!this.state.editing.call.customFlow ?
                                            <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }}>
                                                <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>Retry Interval (Minutes):</div>
                                                <input style={{ flex: '1 0 20%', margin: '10px 15px' }} onChange={this.adjustRetryInterval('retryInterval')} className="textInput" type="number" required value={this.state.editing.call.retryInterval / 60000} ></input>
                                            </div>
                                            : ''}
                                        {!this.state.editing.call.customFlow ?
                                            <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }}>
                                                <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>Ring Timeout (Seconds):</div>
                                                <input style={{ flex: '1 0 20%', margin: '10px 15px' }} onChange={this.callValueChange('timeout')} className="textInput" type="number" required value={this.state.editing.call.timeout} ></input>
                                            </div>
                                            : ''}
                                    </div>
                                    :
                                    <div className="expander" onClick={this.expandClick('phoneOptions', true)}>
                                        <div className="dataHeaders">
                                            <div className="dataHeader">Calls: </div>
                                            <div className="dataValue">{(this.state.editing.call.customFlow ? (initialCustomFlow ? initialCustomFlow.name : "Select a Custom Flow") :
                                                'Confirmation: ' + (this.state.editing.call.preConfirm.enabled ? 'Enabled' : 'Disabled')) +
                                                ' | ' + 'Outbound ID: ' + this.state.editing.call.localAddress
                                            }</div>
                                        </div>
                                    </div>

                                : ''}

                            {this.state.editing.sms.enabled ?
                                this.state.expand.hasOwnProperty('smsOptions') ?
                                    <div className={this.state.expand.phoneOptions ? "expander expanded" : "expander expanding"}>
                                        <div className="dataHeaders" onClick={this.expandClick('smsOptions', false)}>
                                            <div className="dataHeader">SMS: </div>
                                        </div>
                                        
	
                                        <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }}>
                                            <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>Select SMS Survey</div>

                                            <div style={{ flex: '1 0 20%', margin: '10px 15px' }}>
                                                <ReactSuperSelect ajaxDataFetch={() => { return new Promise(async (res, rej) => { var response = await fetch(window.location.origin + '/data?path=' + window.domain + ',Survey Management,data'); if (response.ok) { var ddArray = []; var ddItems = await response.json(); for (var ddItem in ddItems) { ddArray.push({ id: ddItems[ddItem].id, name: ddItems[ddItem].title }) }; res(ddArray) }; }) }} initialValue={{ id: this.state.editing.sms.survey, name: this.state.editing.sms.surveyTitle }} placeholder="No Survey Selected" onChange={this.selectSMSSurvey} />
                                            </div>

                                        </div>
                                        <div>
                                            <div style={{ margin: '10px 25px', lineHeight: '32px' }}>{headerList}</div>
                                            <div>{smsBodyArray}</div>
                                        </div>


                                        <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }}>
                                            <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>Response Timeout (Minutes):</div>
                                            <input style={{ flex: '1 0 20%', margin: '10px 15px' }} onChange={this.smsResponseTimeout('responseTimeout')} className="textInput" type="number" required value={this.state.editing.sms.responseTimeout / 60000} ></input>
                                        </div>

                                    </div>
                                    :
                                    <div className="expander" onClick={this.expandClick('smsOptions', true)}>
                                        <div className="dataHeaders">
                                            <div className="dataHeader">SMS: </div>
                                            <div className="dataValue">{
                                                'Survey: ' + (this.state.editing.sms.survey ? this.state.editing.sms.surveyTitle : 'No Survey Enabled') + ' | ' +
                                                'Response Timeout: ' + (this.state.editing.sms.responseTimeout / 60000) + ' Minutes'
                                            }</div>
                                        </div>
                                    </div>

                                : ''}

                            {this.state.editing.email.enabled ?
                                this.state.expand.hasOwnProperty('emailOptions') ?
                                    <div className={this.state.expand.emailOptions ? "expander expanded" : "expander expanding"}>
                                        <div className="dataHeaders" onClick={this.expandClick('emailOptions', false)}>
                                            <div className="dataHeader">Email: </div>
                                        </div>
                                        <div>
                                            <div style={{ margin: '10px 25px', lineHeight: '32px' }}>{headerList}</div>
                                            <div>{emailSubjectArray}</div>
                                            <div>{emailBodyArray}</div>
                                        </div>
                                        <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }}>
                                            <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>Outbound Address:</div>
                                            <div style={{ flex: '1 0 20%', margin: '10px 15px' }}>
                                                {<ReactSuperSelect dataSource={[{ id: "do-not-reply@dirad.com", name: "do-not-reply@dirad.com" }]} initialValue={{ id: "do-not-reply@dirad.com", name: "do-not-reply@dirad.com" }} clearable={false} closeOnSelectedOptionClick={false} onChange={this.selectOutboundEmail} />}
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', position: 'relative', lineHeight: '54px' }}>
                                            <div style={{ flex: '0 0 250px', paddingLeft: '25px', textAlign: 'left' }}>Response Timeout (Minutes):</div>
                                            <input style={{ flex: '1 0 20%', margin: '10px 15px' }} onChange={this.emailResponseTimeout('responseTimeout')} className="textInput" type="number" required value={this.state.editing.email.responseTimeout / 60000} ></input>
                                        </div>


                                    </div>
                                    :
                                    <div className="expander" onClick={this.expandClick('emailOptions', true)}>
                                        <div className="dataHeaders">
                                            <div className="dataHeader">Email: </div>
                                            <div className="dataValue">{
                                                'Outbound Address: ' + this.state.editing.email.localAddress + ' | ' +
                                                'Response Timeout: ' + (this.state.editing.email.responseTimeout / 60000) + ' Minutes'
                                            }</div>
                                        </div>
                                    </div>

                                : ''}

                            {this.state.expand.hasOwnProperty('scheduling') ?
                                <div className={this.state.expand.scheduling ? "expander expanded" : "expander expanding"}>
                                    <div className="dataHeaders" onClick={this.expandClick('scheduling', false)}>
                                        <div className="dataHeader">Scheduling: </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ margin: '15px', border: this.state.editing.scheduling.now === true ? '2px solid #2A6AA9' : '2px solid #FFFFFF', background: this.state.editing.scheduling.now === true ? 'radial-gradient(#cee 0%, #fff 70%, #fff 100%)' : '#fff', padding: '5px', cursor: 'pointer' }} onClick={this.setScheduleMethod('now')}>
                                            <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueLightning} />
                                            <div>Now</div>
                                        </div>

                                        <div style={{ margin: '15px', border: this.state.editing.scheduling.onReceipt ? '2px solid #2A6AA9' : '2px solid #FFFFFF', background: this.state.editing.scheduling.onReceipt ? 'radial-gradient(#cee 0%, #fff 70%, #fff 100%)' : '#fff', padding: '5px', cursor: 'pointer' }} onClick={this.setScheduleMethod('onReceipt')}>
                                            <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueReceipt} />
                                            <div>On Contact List Receipt</div>
                                        </div>

                                        <div style={{ margin: '15px', border: this.state.editing.scheduling.time ? '2px solid #2A6AA9' : '2px solid #FFFFFF', background: this.state.editing.scheduling.time ? 'radial-gradient(#cee 0%, #fff 70%, #fff 100%)' : '#fff', padding: '5px', cursor: 'pointer' }} onClick={this.setScheduleMethod('time')}>
                                            <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueCalendar} />
                                            <div>Schedule</div>
                                        </div>

                                        <div style={{ margin: '15px', border: this.state.editing.scheduling.variable ? '2px solid #2A6AA9' : '2px solid #FFFFFF', background: this.state.editing.scheduling.variable ? 'radial-gradient(#cee 0%, #fff 70%, #fff 100%)' : '#fff', padding: '5px', cursor: 'pointer' }} onClick={this.setScheduleMethod('variable')}>
                                            <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueFile} />
                                            <div>Date From File</div>
                                        </div>

                                        {false ? <div style={{ margin: '15px', border: this.state.editing.scheduling.escalation ? '2px solid #2A6AA9' : '2px solid #FFFFFF', background: this.state.editing.scheduling.escalation ? 'radial-gradient(#cee 0%, #fff 70%, #fff 100%)' : '#fff', padding: '5px', cursor: 'pointer' }} onClick={this.setScheduleMethod('escalation')}>
                                            <img style={{ margin: '15px', height: '80px' }} src={this.props.img.blueStairsUp} />
                                            <div>Escalation</div>
                                        </div>
                                            : ''}
                                    </div>

                                    {this.state.editing.scheduling.now === true ?
                                        <div>
                                            The notification will be sent immediately after confirmation.
                                        </div>
                                        : ''}

                                    {this.state.editing.scheduling.onReceipt ?
                                        <div>
                                            The notification will be sent whenever a new contact list is received.
                                        </div>
                                        : ''}

                                    {this.state.editing.scheduling.time ?
                                        <div style={{ display: 'flex', justifyContent: 'space-around', margin: '25px' }}>
                                            <div style={{ flex: '0 1 500px' }}>
                                                <div>Send Date and Time:</div>
                                                <Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: 'calc(100% - 40px)', margin: '5px' }} options={{ dateFormat: "Y-m-d h:i K" }} data-enable-time value={this.state.editing.scheduling.time !== true ? new Date(this.state.editing.scheduling.time) : null} onChange={date => { this.selectSimpleSendTime(date[0]) }} />
                                            </div>
                                        </div>
                                        : ''}

                                    {this.state.editing.scheduling.variable ?
                                        <div>
                                            <div style={{ display: 'flex', justifyContent: 'space-around', margin: '25px' }}>
                                                <div style={{ flex: '0 1 500px' }}>
                                                    <div>Choose Date Column:</div>
                                                    {<ReactSuperSelect clearable={false} style={{ flex: '1 0 150px', margin: '0px' }} dataSource={headers} initialValue={{ id: this.state.editing.scheduling.variable, name: this.state.editing.scheduling.variable }} onChange={this.selectSendVariable} />}
                                                </div>
                                            </div>
                                            <div>
                                                <div>Select Time Offset:</div>
                                                <div style={{ display: 'flex', margin: '0px 25px 50px 25px' }}>
                                                    <input style={{ border: '1px solid #bbb', textAlign: 'center' }} type="number" value={Math.abs(this.state.editing.scheduling.offset.value)} onChange={this.selectOffsetValue} ></input>
                                                    <ReactSuperSelect clearable={false} placeholder="Interval" style={{ flex: '1 0 150px', margin: '0px 15px' }} dataSource={[{ id: 'minutes', name: 'minutes' }, { id: 'hours', name: 'hours' }, { id: 'days', name: 'days' }]} initialValue={{ id: this.state.editing.scheduling.offset.unit, name: this.state.editing.scheduling.offset.unit }} onChange={this.selectOffsetUnit} />
                                                    <ReactSuperSelect clearable={false} placeholder="Before/After" style={{ flex: '1 0 150px', margin: '0px 15px' }} dataSource={[{ id: 'before', name: 'before' }, { id: 'after', name: 'after' }]} initialValue={this.state.editing.scheduling.offset.value < 0 ? { id: 'before', name: 'before' } : this.state.editing.scheduling.offset.value > 0 ? { id: 'after', name: 'after' } : null} onChange={this.selectOffsetDirection} />
                                                </div>
                                            </div>
                                        </div>

                                        : ''}

                                    {this.state.editing.scheduling.escalation ?
                                        <div>
                                            This notification will be sent to contacts who fail to meet acknowledgement criteria.
                                        </div>
                                        : ''}

                                    <div style={{ display: 'flex', lineHeight: '40px' }}>
                                        <div className="activeBox" onClick={this.toggleOverride}>
                                            <div className={this.state.editing.scheduling.override ? "enabled" : "disabled"}></div>
                                        </div>
                                        <div>Override Scheduling Restrictions</div>
                                    </div>

                                    <div style={{ display: 'flex', lineHeight: '40px' }}>
                                        <div className="activeBox" onClick={this.toggleMidnightClear}>
                                            <div className={this.state.editing.scheduling.midnightClear ? "enabled" : "disabled"}></div>
                                        </div>
                                        <div>Prevent Notifications From Overflowing Into the Next Day</div>
                                    </div>

                                </div>
                                :
                                <div className="expander" onClick={this.expandClick('scheduling', true)}>
                                    <div className="dataHeaders">
                                        <div className="dataHeader">Scheduling: </div>
                                        <div className="dataValue">{
                                            this.state.editing.scheduling.variable ? 'Based on {' + this.state.editing.scheduling.variable + '}' :
                                                this.state.editing.scheduling.now === true ? 'Send Now' :
                                                    this.state.editing.scheduling.now === 'sent' ? 'Already Sent' :
                                                        this.state.editing.scheduling.onReceipt ? 'Send whenever ' + this.state.file.filename + ' is received' :
                                                            this.state.editing.scheduling.escalation ? 'Escalate from another template' :
                                                                this.state.editing.scheduling.time ? new Date(this.state.editing.scheduling.time).toDateString().substring(4) + ', ' + new Date(this.state.editing.scheduling.time).toLocaleTimeString() :
                                                                    'Select a Scheduling Method'

                                        }</div>
                                    </div>
                                </div>
                            }

                            {this.state.expand.hasOwnProperty('acknowledgment') ?
                                <div className={this.state.expand.acknowledgment ? "expander expanded" : "expander expanding"}>
                                    <div className="dataHeaders" onClick={this.expandClick('acknowledgment', false)}>
                                        <div className="dataHeader">Acknowledgement: </div>
                                    </div>
                                    <div style={{ display: 'flex', lineHeight: '40px' }}>
                                        <div className="activeBox" onClick={this.toggle('acknowledgment')}>
                                            <div className={this.state.editing.acknowledgment ? "enabled" : "disabled"}></div>
                                        </div>
                                        <div>Acknowledgement Enabled</div>
                                    </div>
                                </div>
                                :
                                <div className="expander" onClick={this.expandClick('acknowledgment', true)}>
                                    <div className="dataHeaders">
                                        <div className="dataHeader">Acknowledgement: </div>
                                        <div className="dataValue">{this.state.editing.acknowledgment ? 'Enabled' : 'Disabled'}</div>
                                    </div>
                                </div>
                            }

                            {this.state.expand.hasOwnProperty('condition') ?
                                <div className={this.state.expand.condition ? "expander expanded" : "expander expanding"}>
                                    <div className="dataHeaders" onClick={this.expandClick('condition', false)}>
                                        <div className="dataHeader">Data Filters: </div>
                                    </div>
                                    {conditionArray}
                                </div>
                                :
                                <div className="expander" onClick={this.expandClick('condition', true)}>
                                    <div className="dataHeaders">
                                        <div className="dataHeader">Data Filters: </div>
                                        <div className="dataValue">{this.state.editing.conditions.map((cond) => { return cond.variable }).join(', ')}</div>
                                    </div>
                                </div>
                            }

                            <div className="error" style={{ margin: '30px auto 0px auto' }}>{this.state.error}</div>

                            {this.state.loading ? <div className="loader" style={{ margin: '30px auto 0px auto' }}></div> : <div className="button" style={{ bottom: '25px', margin: '30px auto 0px auto' }} onClick={this.editNotification}>Confirm Notification</div>}
                        </div>
                    </div>
                )
            }



            var delNotification = ""
            if (this.state.deleting) {
                delNotification = (
                    <div className="blackout">
                        <div className="pop">
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div>You Are Removing Notification</div>
                            <div style={{ margin: "15px" }}> {this.state.deleting.name} </div>
                            {this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmDelete}>Delete This Notification</div>}
                        </div>
                    </div>
                )
            }

            return (
                <div className="viewContent">
                    <img src={this.props.img.plus} className="plusButton" alt="Add a Notification" onClick={this.add} />

                    <div className="dataHeaders">
                        <span style={{ flex: '0 0 85px', cursor: 'pointer' }} onClick={this.sort('active')}>Active</span>
                        <span style={{ flex: '1 1 200px', cursor: 'pointer' }} onClick={this.sort('name')}>Name</span>
                        <span style={{ flex: '1 1 200px', cursor: 'pointer' }} onClick={this.sort('file')}>Contact List</span>
                        <span style={{ flex: '0 0 105px' }} ></span>
                    </div>

                    <div className="dataFilters">
                        <ReactSuperSelect clearable={false} style={{ flex: '0 0 85px', margin: '0px' }} customClass="r-ss-active" placeholder="   " dataSource={[{ id: 1, name: 'Active' }, { id: 0, name: 'Not Active' }]} onChange={this.filterByDropdown} />
                        <input style={{ flex: '1 1 200px' }} type="text" onChange={this.filter} value={this.state.filterBy.name ? this.state.filterBy.name : ''} ref="name" data-filterby="name" />
                        <input style={{ flex: '1 1 200px' }} type="text" onChange={this.filter} value={this.state.filterBy.file ? this.state.filterBy.file : ''} ref="file" data-filterby="file" />
                        <span style={{ flex: '0 0 105px' }} ></span>
                    </div>

                    <div style={{ overflow: 'auto', height: 'calc(100% - 85px)' }}>
                        {notificationList}
                    </div>

                    {activeNotification}
                    {delNotification}
                    {wizard[this.state.wizard]}
                    {upload}
                    {add}
                </div>
            );
        } else {
            return (
                <div>

                </div>
            );
        }
    }
}


const icon = "menuBell"
const roles = ["View"]
export { Notifications, icon, roles }